import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CompanyHero from './components/CompanyHero';
import OurStorySection from './components/OurStorySection';
import MissionVisionSection from './components/MissionVisionSection';
import TimelineSection from './components/TimelineSection';
import CompanyCTABand from './components/CompanyCTABand';

export default function CompanyPage() {
  return (
    <>
      <Navbar />
      <main>
        <CompanyHero />
        <OurStorySection />
        <MissionVisionSection />
        <TimelineSection />
        <CompanyCTABand />
      </main>
      <Footer />
    </>
  );
}